<template>
    <v-progress-circular
        v-if="isVisible"
        indeterminate
        color="#888"
        :size="18"
        :width="2"
    />
</template>

<script lang="ts">
import Component from 'vue-class-component'
import Vue from 'vue'
import {Prop} from 'vue-property-decorator'

@Component
export default class Spinner extends Vue
{
    @Prop({type: Number, default: 800})
    delay!: number

    isVisible = false
    showTimeout: ReturnType<typeof setTimeout> | null = null

    mounted() {
        if (this.delay) {
            this.showTimeout = setTimeout(() => {
                this.isVisible = true
                this.removeTimeout()
            }, this.delay)
        } else {
            this.isVisible = true
        }
    }

    removeTimeout() {
        if (this.showTimeout) {
            clearTimeout(this.showTimeout)
            this.showTimeout = null
        }
    }

    destroyed() {
        this.removeTimeout()
    }
}
</script>
